import { render, staticRenderFns } from "./employment_history_yukon.vue?vue&type=template&id=4700e98f&"
import script from "./employment_history_yukon.vue?vue&type=script&lang=js&"
export * from "./employment_history_yukon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports